import React from 'react';
import Bar from '@splunk/dashboard-visualizations/Bar';

export default () => (
    <Bar
        options={{
            'axisLabelsY.axisVisibility': 'show',
        }}
        encoding={{
            x: 'primary.component',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component', groupby_rank: '0' }, { name: 'count' }],
                    columns: [
                        ['ApplicationLicense', 'DatabaseDirectoryManager', 'IndexWriter'],
                        ['166238', '8904', '2327'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
